import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    inner: {
        paddingLeft: '40px',
        paddingRight: '5px',
        marginTop: '15px'
    }
}